module.exports = __webpack_public_path__ + "img/x_sqrt_rooting.ed2bfa6e.svg";